import { useTranslation } from '@thoughtspot/i18n';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { FeatureManagementTranslationKeys } from '../constants';
import styles from './disable-feature-modal.module.scss';
export const DisableFeatureModal = ({ isOpen, featureName, onDismiss, onConfirm, }) => {
    const { t } = useTranslation();
    return (React.createElement(Modal, { isOpen: isOpen, onDismiss: onDismiss, size: ModalSize.SMALL, title: t(FeatureManagementTranslationKeys.DISABLE_MODAL_TITLE, {
            featureName,
        }), dismissButton: {
            text: t('CANCEL'),
            onClick: onDismiss,
        }, confirmButton: {
            text: t(FeatureManagementTranslationKeys.DISABLE_MODAL_CONFIRM),
            onConfirm,
        }, "data-testid": "disable-feature-modal" },
        React.createElement(Vertical, { spacing: "f", className: styles.disableModalContent },
            React.createElement(Typography, { variant: "p", noMargin: true }, t(FeatureManagementTranslationKeys.DISABLE_MODAL_WARNING)),
            React.createElement(Typography, { variant: "p", noMargin: true }, t(FeatureManagementTranslationKeys.DISABLE_MODAL_INFO)))));
};
//# sourceMappingURL=disable-feature-modal.js.map